import { NextImageProps } from '~components/NextImage/NextImage.types';
import { ServiceLabelProps } from '~components/ServiceLabel/ServiceLabel.types';
import { PropsWithId } from '~types/Props.types';

export enum EventCardMods {
  Blue = 'blue',
  Black = 'black',
}

export type EventCardProps = {
  hasForm?: boolean;
  date: number;
  formats: string[];
  documentId: string;
  timezone: string;
  title: string;
  url: string;
  image?: NextImageProps;
  mod?: EventCardMods;
  type?: string;
  services?: PropsWithId<ServiceLabelProps>[];
};
